import axios from 'axios';

let prefix = "/user-hero"

const UserHeroApi = {
	listUserHero(payload) {
		return axios.get(prefix + "/list", { params: payload })
	},
	createUserHero(payload) {
		return axios.post(prefix + "/create", payload)
	},
	updateUserHero(payload) {
		return axios.post(prefix + "/update", payload)
	},
	archiveUserHero(payload) {
		return axios.delete(prefix + "/archive", { params: payload })
	},
}

export default UserHeroApi;